import React from "react";
import { CheckCircle2, AlertCircle, Loader2, X } from "lucide-react";

const STATUS_ICON = {
  done: <CheckCircle2 size={16} className="pii-file__icon pii-file__icon--done" />,
  error: <AlertCircle size={16} className="pii-file__icon pii-file__icon--error" />,
  uploading: <Loader2 size={16} className="pii-file__icon pii-file__icon--spin" />,
  pending: <span className="pii-file__icon pii-file__icon--pending" />,
};

const UploadFileList = ({ files, onRemove, busy }) => {
  if (files.length === 0) return null;

  return (
    <ul className="pii-files">
      {files.map((f) => (
        <li key={f.id} className={`pii-file pii-file--${f.status}`}>
          {STATUS_ICON[f.status]}
          <div className="pii-file__body">
            <span className="pii-file__name">{f.name}</span>
            {f.status === "uploading" && (
              <div className="pii-file__bar">
                <div className="pii-file__bar-fill" style={{ width: `${f.progress}%` }} />
              </div>
            )}
            {f.error && <span className="pii-file__error">{f.error}</span>}
          </div>
          {f.status !== "uploading" && (
            <button
              type="button"
              className="pii-file__remove"
              onClick={() => onRemove(f.id)}
              disabled={busy}
              aria-label={`Remove ${f.name}`}
            >
              <X size={14} />
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};

export default UploadFileList;
